import React from 'react';
import styled from 'styled-components';

import { positioning } from 'ui/theme/utils';
import { useChildrenWithProps } from 'hooks';

// eslint-disable-next-line no-unused-vars
const StyledUl = styled(({ direction, alignItems, zIndex, ...rest }) => <ul {...rest} />)(
  ({ direction, alignItems, zIndex }) => ({
    display: 'flex',
    width: 'fit-content',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    flexDirection: {
      up: 'column-reverse',
      down: 'column',
      left: 'row-reverse',
      right: 'row',
    }[direction],
    justifyContent: 'center',
    alignItems: alignItems || 'center',
    zIndex: zIndex || 'auto',
  })
);

const StyledList = styled(StyledUl)`
  ${(props) => positioning(props)}
`;

export const Directions = {
  Up: 'up',
  Down: 'down',
  Left: 'left',
  Right: 'right',
};

const FloatingMenu = ({
  slideSpeed = 500,
  direction = Directions.Down,
  isOpen = false,
  spacing = 8,
  children,
  ...rest
}) => {
  const childrenWithProps = useChildrenWithProps(children, () => ({
    isOpen,
    slideSpeed,
    direction,
    spacing,
  }));

  return (
    <StyledList direction={direction} {...rest}>
      {childrenWithProps}
    </StyledList>
  );
};

export default FloatingMenu;
